<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营商管理</el-breadcrumb-item>
      <el-breadcrumb-item>全国门店信息汇总表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
             <el-select v-model="keywords.regional" placeholder="请选择区域分布" class="select"  style="width: 150px;">
               <el-option label="请选择区域分布" value=""></el-option>
               <el-option
                 v-for="item in regionalList" :key="item.value" :label="item.label" :value="item.value">
               </el-option>
             </el-select>
           </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.province" placeholder="请输入省" style="width: 100px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.city" placeholder="请输入市" style="width: 100px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.district" placeholder="请输入区" style="width: 100px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.name" placeholder="请输入门店名称" style="width: 130px;"></el-input>
          </el-form-item>
         <el-form-item label="">
            <el-select v-model="keywords.category" placeholder="请选择类别" class="select"  style="width: 120px;">
              <el-option label="请选择类别" value=""></el-option>
              <el-option
                v-for="item in categoryList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.head" placeholder="请输入负责人" style="width: 120px;"></el-input>
          </el-form-item>
          <el-form-item label="" v-if="SubRule_GlassJigouInformation_CompleteInfo">
            <el-input v-model="keywords.phone" placeholder="请输入电话" style="width: 120px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.address" placeholder="请输入地址" style="width: 120px;"></el-input>
          </el-form-item>
          <el-form-item label="" v-if="SubRule_GlassJigouInformation_CompleteInfo">
             <el-select v-model="keywords.status" placeholder="请选择状态" class="select"  style="width: 120px;">
               <el-option label="请选择状态" value=""></el-option>
               <el-option
                 v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
               </el-option>
             </el-select>
           </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <TencentyunCosUploadExcel @change="changeTencentyunCosUploadExcel" v-if="SubRule_GlassJigouInformation_ImportExcel"></TencentyunCosUploadExcel>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table v-loading="loading" :data="dataList" border stripe >
          <el-table-column prop="Regional" label="区域分布" min-width="10%"></el-table-column>
          <el-table-column prop="Province" label="省" min-width="10%"></el-table-column>
          <el-table-column prop="City" label="市" min-width="10%"></el-table-column>
          <el-table-column prop="District" label="区" min-width="10%"></el-table-column>
          <el-table-column prop="Name" label="门店名称" min-width="15%"></el-table-column>
          <el-table-column prop="Category" label="类别" min-width="10%"></el-table-column>
          <el-table-column prop="Head" label="负责人" min-width="10%"></el-table-column>
          <el-table-column prop="Phone" label="电话" min-width="15%" v-if="SubRule_GlassJigouInformation_CompleteInfo"></el-table-column>
          <el-table-column prop="Address" label="地址" min-width="20%"></el-table-column>
          <el-table-column prop="Operating" label="所属运营" min-width="10%"></el-table-column>
          <el-table-column prop="Status" label="状态" min-width="10%" v-if="SubRule_GlassJigouInformation_CompleteInfo"></el-table-column>
          <el-table-column prop="Note" label="备注" min-width="10%"></el-table-column>
          <el-table-column label="操作" min-width="25%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_GlassJigouInformation_Modify" @click="goModify(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_GlassJigouInformation_CompleteInfo" @click="apiGetGlassJigouSaleStatisticalList(scope.row.Name)">近12个月销售机开通数量</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加" name="second" v-if="SubRule_GlassJigouInformation_Add">
        <el-form :model="addData" ref="addDataRef" label-width="75px">
          <el-form-item label="区域分布" class="addAdminForm">
            <el-select v-model="addData.regional" placeholder="请选择区域分布" class="select">
             <el-option
               v-for="item in regionalList" :key="item.value" :label="item.label" :value="item.value">
             </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="省" class="addAdminForm">
            <el-input v-model="addData.province" placeholder="请输入省"></el-input>
          </el-form-item>
          <el-form-item label="市" class="addAdminForm">
            <el-input v-model="addData.city" placeholder="请输入市"></el-input>
          </el-form-item>
          <el-form-item label="区" class="addAdminForm">
            <el-input v-model="addData.district" placeholder="请输入区"></el-input>
          </el-form-item>
          <el-form-item label="门店名称" class="addAdminForm">
            <Rsljigou :propsjigouid="addData.jigouid" :propsjigouname="addData.name" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="类别">
            <el-select v-model="addData.category" placeholder="请选择类别" class="select">
              <el-option
                v-for="item in categoryList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="负责人" class="addAdminForm">
            <el-input v-model="addData.head" placeholder="请输入负责人"></el-input>
          </el-form-item>
          <el-form-item label="电话" class="addAdminForm">
            <el-input v-model="addData.phone" placeholder="请输入电话"></el-input>
          </el-form-item>
          <el-form-item label="地址" class="addAdminForm">
            <el-input v-model="addData.address" placeholder="请输入地址"></el-input>
          </el-form-item>
          <el-form-item label="所属运营" class="addAdminForm">
            <el-input v-model="addData.operating" placeholder="请输入所属运营"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="addData.status" placeholder="请选择状态" class="select">
              <el-option
                v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" class="addAdminForm">
            <el-input v-model="addData.note" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <el-tab-pane label="修改" name="three" disabled="disabled">
        <GlassJigouInformationModify ref="SubVuethree" v-on:triggerFunc="BackToFirst"></GlassJigouInformationModify>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->

    <!-- 弹出框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogShow" width="40%" :close-on-click-modal="false">
      <el-table :data="dialogList" border stripe >
        <el-table-column prop="Yearmonth" label="日期" min-width="10%"></el-table-column>
        <el-table-column prop="Num1" label="5.0销售机" min-width="10%"></el-table-column>
        <el-table-column prop="Num2" label="6.0销售机" min-width="10%"></el-table-column>
        <el-table-column prop="Num3" label="6.0T销售机" min-width="10%"></el-table-column>
        <el-table-column prop="Num4" label="mini销售机" min-width="10%"></el-table-column>
        <el-table-column prop="Num5" label="合计" min-width="10%"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 弹出框 end -->

  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import GlassJigouInformationModify from '@/componentsSubVue/GlassJigouInformationModify.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou,
    TencentyunCosUploadExcel,
    GlassJigouInformationModify
  },
  name: 'MyGlassJigouInformation',
  data () {
    return {
      loading: false,
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      regionalList: [
        { label: '华北地区', value: '华北地区' },
        { label: '东北地区', value: '东北地区' },
        { label: '华东地区', value: '华东地区' },
        { label: '中南地区', value: '中南地区' },
        { label: '西南地区', value: '西南地区' },
        { label: '西北地区', value: '西北地区' }
      ],
      categoryList: [
        { label: '单店', value: '单店' },
        { label: '区域代理', value: '区域代理' },
        { label: '老门店', value: '老门店' },
        { label: '老代理', value: '老代理' },
        { label: '搭接店', value: '搭接店' },
        { label: '渠道商', value: '渠道商' },
        { label: '分公司', value: '分公司' }
      ],
      statusList: [
			  { label: '已签约', value: '已签约' },
        { label: '营业中', value: '营业中' },
        { label: '闭店', value: '闭店' },
        { label: '内部使用', value: '内部使用' }
      ],
      // 查询客户
      keywords: {
        regional: '',
        province: '',
        city: '',
        district: '',
        name: '',
        category: '',
        head: '',
        phone: '',
        address: '',
        status: ''
      },
      // 添加
      addData: {
        regional: '',
        province: '',
        city: '',
        district: '',
        jigouid: '',
        name: '',
        category: '',
        head: '',
        phone: '',
        address: '',
        operating: '',
        status: '',
        note: ''
      },
      SubRule_GlassJigouInformation_Add: false,
      SubRule_GlassJigouInformation_Modify: false,
      SubRule_GlassJigouInformation_ImportExcel: false,
      SubRule_GlassJigouInformation_CompleteInfo: false,
      dialogTitle: '',
      dialogList: [],
      dialogShow: false
    }
  },
  mounted () {
    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_GlassJigouInformation_Add', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_GlassJigouInformation_Add = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_GlassJigouInformation_Modify', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_GlassJigouInformation_Modify = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_GlassJigouInformation_ImportExcel', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_GlassJigouInformation_ImportExcel = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_GlassJigouInformation_CompleteInfo', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_GlassJigouInformation_CompleteInfo = true
      } else {
        that.SubRule_GlassJigouInformation_CompleteInfo = false
      }
      // 不能看完整的数据，那就只能看已签约和营业中
      if (!that.SubRule_GlassJigouInformation_CompleteInfo) {
        that.keywords.status = '已签约;营业中'
      }
      that.apiGetGlassJigouInformationNum()
      that.apiGetGlassJigouInformationList()
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetGlassJigouInformationList()
    },
    changeTencentyunCosUploadExcel (url) {
      this.apiExcelImportGlassJigouInformation(url)
    },
    changeRsljigou (vid, vname) {
      this.addData.jigouid = vid
      this.addData.name = vname
    },
    clickreturn () {
      this.activeName = 'first'
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetGlassJigouInformationList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetGlassJigouInformationNum()
      this.apiGetGlassJigouInformationList()
    },
    handleClick (tab, event) {
      if (tab.name == 'second') {
        this.addData.regional = '华北地区'
        this.addData.province = ''
        this.addData.city = ''
        this.addData.district = ''
        this.addData.name = ''
        this.addData.category = '单店'
        this.addData.head = ''
        this.addData.phone = ''
        this.addData.address = ''
        this.addData.operating = ''
        this.addData.status = '已签约'
        this.addData.note = ''
      }
    },
    clickadd () {
      this.apiAddGlassJigouInformation()
    },
    // 修改
    goModify (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData(row, this.regionalList, this.categoryList, this.statusList, this.SubRule_GlassJigouInformation_CompleteInfo)
    },
    apiGetGlassJigouInformationList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        regional: that.keywords.regional,
        province: that.keywords.province,
        city: that.keywords.city,
        district: that.keywords.district,
        name: that.keywords.name,
        category: that.keywords.category,
        head: that.keywords.head,
        phone: that.keywords.phone,
        address: that.keywords.address,
        status: that.keywords.status
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetGlassJigouInformationList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiGetGlassJigouInformationNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        regional: that.keywords.regional,
        province: that.keywords.province,
        city: that.keywords.city,
        district: that.keywords.district,
        name: that.keywords.name,
        category: that.keywords.category,
        head: that.keywords.head,
        phone: that.keywords.phone,
        address: that.keywords.address,
        status: that.keywords.status
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetGlassJigouInformationNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddGlassJigouInformation: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        regional: that.addData.regional,
        province: that.addData.province,
        city: that.addData.city,
        district: that.addData.district,
        name: that.addData.name,
        category: that.addData.category,
        head: that.addData.head,
        phone: that.addData.phone,
        address: that.addData.address,
        operating: that.addData.operating,
        status: that.addData.status,
        note: that.addData.note
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddGlassJigouInformation, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.apiGetGlassJigouInformationNum()
            that.apiGetGlassJigouInformationList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetGlassJigouSaleStatisticalList: function (name) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetGlassJigouSaleStatisticalList, Qs.stringify(data))
        .then(function (response) {
          console.log(response.data)
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          if (response.data.Code == 200) {
            that.dialogTitle = name + '【近12个月销售机开通数量】'
            that.dialogShow = true
            that.dialogList = response.data.List
          }
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelImportGlassJigouInformation: function (url) {
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fileurl: url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelImportGlassJigouInformation, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
